import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import { brand } from './lib/brand';
import './styles/globals.css';

// Skin-specific CSS hangs off this attribute (see globals.css).
document.documentElement.dataset.brand = brand.id;

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
